import { render, staticRenderFns } from "./Apresentacoes.vue?vue&type=template&id=f03be4d4&"
import script from "./Apresentacoes.vue?vue&type=script&lang=js&"
export * from "./Apresentacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports